import { EventTemplateStatus } from '../types/eventTemplateStatus';

export type EventTemplatePermissionsReturnType = {
  canDeleteDraftOrChangeOwner: boolean;
};

export const EventTemplatePermissions = (
  templateStatus: string,
  templateOwnerId: number | null | undefined,
  currentuserId: number,
  currentUserRole: string | undefined,
  hasManageTemplatePermission: boolean,
): EventTemplatePermissionsReturnType => {
  const isDraft = templateStatus === 'draft';
  const isOwner = templateOwnerId === currentuserId;
  const isQuality = currentUserRole === 'quality';
  const canDeleteDraftOrChangeOwner = isDraft && hasManageTemplatePermission && (isOwner || isQuality);
  return { canDeleteDraftOrChangeOwner };
};

const CREATE_DRAFT_STATUSES: EventTemplateStatus[] = ['effective', 'for_approval', 'approval_declined'];

export type EventTemplateHeaderActions = {
  showChangeOwner: boolean;
  showDeleteDraft: boolean;
  showArchive: boolean;
  showRestore: boolean;
  hasVisibleActions: boolean;
};

export const eventTemplateHeaderActions = (
  templateStatus: EventTemplateStatus,
  isActive: boolean,
  canDeleteDraftOrChangeOwner: boolean,
): EventTemplateHeaderActions => {
  const showArchive = isActive && templateStatus === 'effective';
  const showRestore = !isActive;

  return {
    showChangeOwner: canDeleteDraftOrChangeOwner,
    showDeleteDraft: canDeleteDraftOrChangeOwner,
    showArchive,
    showRestore,
    hasVisibleActions: canDeleteDraftOrChangeOwner || showArchive || showRestore,
  };
};

export type EventTemplateRowActionsVisibility = {
  showArchive: boolean;
  showRestore: boolean;
  showCreateDraft: boolean;
  showMakeEffective: boolean;
  showChangeOwner: boolean;
  showDeleteDraft: boolean;
  hasVisibleActions: boolean;
};

export const eventTemplateRowActions = (
  template: { status: EventTemplateStatus; active: boolean; ownerId?: number | null },
  currentUserId: number,
  isQualityUser: boolean,
): EventTemplateRowActionsVisibility => {
  const showArchive = template.active && template.status === 'effective';
  const showRestore = !template.active;
  const showCreateDraft = template.active && CREATE_DRAFT_STATUSES.includes(template.status);
  const showDraftActions = template.status === 'draft' && (isQualityUser || template.ownerId === currentUserId);

  return {
    showArchive,
    showRestore,
    showCreateDraft,
    showMakeEffective: showDraftActions,
    showChangeOwner: showDraftActions,
    showDeleteDraft: showDraftActions,
    hasVisibleActions: showArchive || showRestore || showCreateDraft || showDraftActions,
  };
};
